import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
import { selector } from "gsap";

const BlogTable = ({
  blogPosts,
  handleEdit,
  handleDelete,
  currentPage,
  totalRows,
  onPageChange,
  perPage,
  onPerPageChange,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const handleDeleteClick = (id) => {
    setSelectedId(id);
    setShowModal(true);
  };

  const confirmDelete = () => {
    handleDelete(selectedId);
    setShowModal(false);
  };

  const columns = [
    {
      name: <div>Title</div>,
      selector: (row) => row.title || "Untitled",
      sortable: true,
      // wrap: true,
      width: "500px",
    },
    {
      name: <div>Author</div>,
      selector: (row) => row.author || "Unknown",
      sortable: true,
    },
    {
      name: <div>Category</div>,
      selector: (row) => row.category || "No Category",
      sortable: true,
    },
    {
      name: <div>Published On</div>,
      selector: (row) =>
        row.createdAt
          ? new Date(row.createdAt).toLocaleDateString()
          : "No Date",
      sortable: true,
    },
    {
      name: "Thumbnail",
      cell: (row) => (
        <img
          src={row.thumbnail || "https://via.placeholder.com/50"}
          alt={row.title || "No Thumbnail"}
          width="50"
          height="50"
          style={{ borderRadius: "5px" }}
        />
      ),
      ignoreRowClick: true,
    },
    {
      name: <div>Last Updated </div>,
      selector: (row) =>
        row.updatedAt
          ? new Date(row.updatedAt).toLocaleDateString()
          : "No Updates",
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="d-flex justify-content-end">
          <Button
            variant="link"
            onClick={() => handleEdit(row)}
            className="me-2"
          >
            <FontAwesomeIcon icon={faEdit} />
          </Button>
          {/* <Button
            variant="link"
            className="text-danger"
            onClick={() => handleDelete(row._id)}
          >
            <FontAwesomeIcon icon={faTrash} />
          </Button> */}
          <Button
            variant="link"
            className="text-danger"
            onClick={() => handleDeleteClick(row._id)}
          >
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        </div>
      ),
      ignoreRowClick: true,
    },
  ];

  // const customStyles = {
  //   headCells: {
  //     style: {
  //       backgroundColor: "#f7f8fa",
  //       fontWeight: "bold",
  //     },
  //   },
  //   cells: {
  //     style: {
  //       overflowWrap: "break-word",
  //     },
  //   },
  // };

  const customStyles = {
    table: {
      style: {
        // backgroundColor: "#7cc9fd00",
      },
    },
    header: {
      style: {
        backgroundColor: "#7cc9fd26",
      },
    },
    head: {
      style: {
        backgroundColor: "#7cc9fd26",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#7cc9fd26",
      },
    },
    headCells: {
      style: {
        backgroundColor: "#7cc9fd26",
        fontWeight: "bold",
        color: "#333",
      },
    },
    rows: {
      style: {
        backgroundColor: "#7cc9fd26",
        fontSize: "14px",
      },
    },
    cells: {
      style: {
        backgroundColor: "#7cc9fd26",
        overflowWrap: "break-word",
      },
    },
    pagination: {
      style: {
        backgroundColor: "#7cc9fd26",
        color: "#333",
        borderTop: "1px solid #ccc",
        padding: "10px",
      },
    },
  };

  return (
    <div className="table-container">
      {/* <DataTable
        columns={columns}
        data={blogPosts || []}
        noDataComponent="No blog posts available."
        customStyles={customStyles}
        highlightOnHover
        striped
      /> */}
      <DataTable
        key={`page-${currentPage}`}
        title="Admin Blogs"
        columns={columns}
        data={blogPosts || []}
        // pagination
        highlightOnHover
        striped
        customStyles={customStyles}
        noDataComponent="No blog posts available."
        responsive
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        paginationPerPage={perPage}
        paginationDefaultPage={currentPage}
        onChangePage={onPageChange}
        onChangeRowsPerPage={onPerPageChange}
      />
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this blog post?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default BlogTable;
